(function () {
  const COUNT_SELECTOR = 'a.wishlist-link #wt-count';
  const BUTTON_SELECTOR = ".wt-button";

  // Enhanced counter function with persistent monitoring
  window.renderWishlistCount = function renderWishlistCount() {
    const wishlistCountEl = document.querySelector(COUNT_SELECTOR);
    if (!wishlistCountEl) {
      // If element doesn't exist yet, try again shortly
      setTimeout(window.renderWishlistCount, 50);
      return;
    }

    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const count = wishlist.length;
    
    // Set both text content and data attribute for redundancy
    wishlistCountEl.textContent = count;
    wishlistCountEl.setAttribute('data-wishlist-count', count);
    
    // Force display styles
    if (count > 0) {
      wishlistCountEl.style.display = 'flex';
      wishlistCountEl.style.visibility = 'visible';
      wishlistCountEl.style.opacity = '1';
    } else {
      wishlistCountEl.style.display = 'none';
      wishlistCountEl.style.visibility = 'hidden';
    }

    // Add a class for easier CSS targeting
    wishlistCountEl.classList.add('wishlist-counter-initialized');
  };

  // Persistent counter monitoring
  function startCounterMonitoring() {
    // Check counter every 100ms for the first 5 seconds
    let checks = 0;
    const maxChecks = 50; // 5 seconds at 100ms intervals
    
    const monitorInterval = setInterval(() => {
      window.renderWishlistCount();
      checks++;
      
      if (checks >= maxChecks) {
        clearInterval(monitorInterval);
        // Switch to less frequent monitoring
        setInterval(window.renderWishlistCount, 1000);
      }
    }, 100);
  }

  function initButtons() {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    document.querySelectorAll(BUTTON_SELECTOR).forEach(button => {
      const handle = button.dataset.productHandle;
      if (wishlist.includes(handle)) {
        button.classList.add("active");
        // Also set data attribute for CSS targeting
        button.setAttribute('data-wishlist-active', 'true');
      } else {
        button.classList.remove("active");
        button.removeAttribute('data-wishlist-active');
      }
    });
  }


  function showWishlistToast(message) {
  const toast = document.getElementById('wishlist-toast');
  if (!toast) return;

  toast.textContent = message;
  toast.classList.add('show');

  setTimeout(() => {
    toast.classList.remove('show');
  }, 2500); // hide after 2.5s
}


  function toggleWishlist(button) {
    const handle = button.dataset.productHandle;
    if (!handle) return;

    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    let message = "";
    if (!wishlist.includes(handle)) {
      wishlist.push(handle);
      button.classList.add("active");
      button.setAttribute('data-wishlist-active', 'true');
      message = "Added to Wishlist ❤️";
    } else {
      wishlist = wishlist.filter(h => h !== handle);
      button.classList.remove("active");
      button.removeAttribute('data-wishlist-active');
       message = "Removed from Wishlist 💔";
    }

    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    showWishlistToast(message);
    
    // Force immediate counter update with multiple calls
    window.renderWishlistCount();
    setTimeout(window.renderWishlistCount, 10);
    setTimeout(window.renderWishlistCount, 50);
  }

  // Enhanced event delegation
  document.addEventListener("click", function (e) {
    const button = e.target.closest(BUTTON_SELECTOR);
    if (button) toggleWishlist(button);
  });

  function init() {
    // Initialize counter immediately
    window.renderWishlistCount();
    initButtons();

    // Multiple initialization points
    setTimeout(window.renderWishlistCount, 10);
    setTimeout(window.renderWishlistCount, 100);
    setTimeout(window.renderWishlistCount, 500);
    
    // Start persistent monitoring
    startCounterMonitoring();
    
    // Update when page becomes visible
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        setTimeout(window.renderWishlistCount, 10);
        setTimeout(window.renderWishlistCount, 100);
      }
    });

    // Also update on window focus
    window.addEventListener('focus', function() {
      setTimeout(window.renderWishlistCount, 10);
    });
  }

  // Robust initialization
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // SPA navigation detection with enhanced timing
  let currentUrl = location.href;
  setInterval(() => {
    if (location.href !== currentUrl) {
      currentUrl = location.href;
      setTimeout(() => {
        initButtons();
        // Multiple counter updates on navigation
        window.renderWishlistCount();
        setTimeout(window.renderWishlistCount, 10);
        setTimeout(window.renderWishlistCount, 100);
        setTimeout(window.renderWishlistCount, 300);
      }, 100);
    }
  }, 100);

  // MutationObserver to watch for DOM changes that might remove our counter
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if our counter element was added/removed
            if (node.querySelector && node.querySelector(COUNT_SELECTOR)) {
              shouldUpdate = true;
            }
            if (node.matches && node.matches(COUNT_SELECTOR)) {
              shouldUpdate = true;
            }
          }
        });
      }
    });
    
    if (shouldUpdate) {
      setTimeout(window.renderWishlistCount, 10);
    }
  });

  // Start observing when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  } else {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();